import { ContentProgressEventCode } from 'src/types/api/contentProgress';
import { ContentProgressStatus } from 'src/types/contentProgress';
import { ClientLog } from 'src/constants/clientLog';
import ClientLogger from 'src/utils/logger';

/**
 * This utility function takes a progress event code and converts the event to the appropriate progress status.
 */
export const toContentProgressStatus: (
  progressEventCode: ContentProgressEventCode
) => ContentProgressStatus = (progressEventCode) => {
  switch (progressEventCode) {
    case 'contentStart':
    case 'contentInProgress':
      return ContentProgressStatus.IN_PROGRESS;
    case 'contentComplete':
      return ContentProgressStatus.COMPLETED;
    default:
    {
      const errorMessage = `Unknown progress status code: ${progressEventCode}`;
      const error = new Error(errorMessage);
      ClientLogger.error(ClientLog.PayloadValidationError, error, {
        progressEventCode,
        url: window.location.href,
      });
      throw error;
    }
  }
};
